import { getMessageFromError } from '../utils/functions'

const PREFIX = 'admin/user'

function formatUserDropdownLabel(user) {
  const name = `${(user.first_name || '').trim()} ${(user.last_name || '').trim()}`.trim()
  const handle = user.handle_name ? ` (@${user.handle_name})` : ''
  const mobile = user.mobile_number ? ` · ${user.mobile_number}` : ''
  const base = `${name}${handle}`.trim() || user.handle_name || user.email || 'Unknown user'
  return `${base}${mobile}`.trim()
}

export default {
  async create({ commit }, data) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.post(`${PREFIX}/create`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      // Manage Error
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  async get({ commit }, params) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${PREFIX}/portal-list`, { params })
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })

      if (params.type === 'dropdown') {
        const result = (res.data.data.results || []).map((u) => ({
          value: u._id,
          label: formatUserDropdownLabel(u)
        }))
        return { data: result }
      }

      commit('SET_STATE', {
        action: 'records',
        data: res.data.data.results
      })
      commit('SET_STATE', {
        action: 'total',
        data: res.data.data.totalResults
      })
      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.data.totalResults
      })
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  async getTabCounts({ commit }) {
    try {
      const res = await this.$http.get(`${PREFIX}/tab-counts`)
      return res.data
    } catch (error) {
      const { message } = getMessageFromError(error)
      return Promise.reject({ message })
    }
  },

  async delete({ commit }, id) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.delete(`/${PREFIX}/delete/${id}`)
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  async update({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.put(`${PREFIX}/update/${id}`, data)
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  async show({ commit }, id) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${PREFIX}/details/${id}`)
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'record',
        data: res.data.data
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  async subscriptionList({ commit }, params) {
    commit('SET_STATE', {
      action: 'subscriptionListLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`admin/subscription/list`, { params })
      commit('SET_STATE', {
        action: 'subscriptionListLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'subscriptionRecords',
        data: res.data.data.results
      })
      commit('SET_STATE', {
        action: 'subscriptionTotal',
        data: res.data.data.totalResults
      })
      commit('SET_STATE', {
        action: 'subscriptionFilteredCount',
        data: res.data.data.totalResults
      })
      commit('SET_STATE', {
        action: 'subscriptionUserDetail',
        data: res.data.user_details
      })
    } catch (error) {
      commit('SET_STATE', {
        action: 'subscriptionListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  async getRefferdUsers({ commit }, params) {
    commit('SET_STATE', {
      action: 'refferdUsersLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${PREFIX}/referred-user-list`, { params })
      commit('SET_STATE', {
        action: 'refferdUsersLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'refferdUsers',
        data: res.data.data.referred_users
      })
    } catch (error) {
      commit('SET_STATE', {
        action: 'refferdUsersLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },
}
